import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { Widget } from "./Widget";
import React, { useState, useEffect } from "react";

export const WidgetReservasDelDia = ({ Fecha, WidgetKey }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { Varios: { FormateoFechaPara_yyyyMMdd } } = require('neftis7_apicaller');
  const { VEN_Reservas_Cabecera: { function_VEN_Reservas_Cabecera_Resumen } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const resultData = await function_VEN_Reservas_Cabecera_Resumen(await FormateoFechaPara_yyyyMMdd(Fecha), await FormateoFechaPara_yyyyMMdd(Fecha));

      if (resultData && resultData.data && resultData.data.length > 0 && resultData.data[0]) {
        setData(resultData.data[0]);
      } else {
        setData(null); // o {} si querés que no rompa
      }

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getData();
  }, [Fecha, WidgetKey]);

  return (
    <div>
      {data && (
        <div className="widgetDobleAncho">
          <div className="title">
            <AccountBalanceWalletOutlinedIcon
              className="icon"
              style={{
                backgroundColor: "rgba(128, 0, 128, 0.2)",
                color: "purple",
                width: "30px",
                height: "30px",
                margin: "0px 15px 0px 0px "
              }}
            />{" "}
            RESERVAS
          </div>
          <br />
          <span className="title">VENTA</span>
          <br />
          <span className="title">
            Total: {data.CantidadReservas ?? "-"} (L:{data.CantidadReservasLocal ?? "-"} - W:{data.CantidadReservasWeb ?? "-"})
          </span>
          <br />
          <span className="title">
            Total: $
            {data.ImporteReservas !== undefined ? Math.round(data.ImporteReservas).toLocaleString('es-AR') : "-"}
            (L: $
            {data.ImporteReservasLocal !== undefined ? Math.round(data.ImporteReservasLocal).toLocaleString('es-AR') : "-"} - W: $
            {data.ImporteReservasWeb !== undefined ? Math.round(data.ImporteReservasWeb).toLocaleString('es-AR') : "-"})
          </span>
          <br />
          <span className="percentagePositive">
            OCUPACIÓN - Reservas: {data.CantidadReservasEfectivo ?? "-"} (L:{data.CantidadReservasEfectivoLocal ?? "-"} - W:{data.CantidadReservasEfectivoWeb ?? "-"})
          </span>
          <br />
          <span className="percentagePositive">
            Participantes: {data.IntegrantesEfectivo ?? "-"} (L:{data.IntegrantesEfectivoLocal ?? "-"} - W:{data.IntegrantesEfectivoWeb ?? "-"})
          </span>
          <br />
          <span className="percentagePositive">
            Datos: {data.IntegrantesCargadosEfectivo ?? "-"} (L:{data.IntegrantesCargadosEfectivoLocal ?? "-"} - W:{data.IntegrantesCargadosEfectivoWeb ?? "-"})
          </span>
          <br />
          <span className="percentagePositive">
            Check In: {data.IntegrantesCargadosConCheckInEfectivo ?? "-"} (L:{data.IntegrantesCargadosConCheckInEfectivoLocal ?? "-"} - W:{data.IntegrantesCargadosConCheckInEfectivoWeb ?? "-"})
          </span>
          <br />
          <br />
          <a href={"VEN_Reservas_"} className="tituloLink">
            Ver Reservas
          </a>
        </div>
      )}
    </div>
  );
};
